module.exports = __webpack_public_path__ + "media/images/add_to_apple_wallet-8f140888634b5cfa13419afeb1988cb3.png";